let paramsAffiliateId;

if (params.get('provider_id') && params.get('provider_id') !== '') {
    paramsAffiliateId = params.get('provider_id')
}

async function setAffiliateAttributes(affiliate) {
    await fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
            attributes: {
                'affiliate_session': affiliate ? 'true' : 'false',
                'affiliate_id': affiliate ? affiliate.id : '',
                'affiliate_type': affiliate ? affiliate.type : ''
            }
        })
    })
    .then(function(response) {
        if (affiliate) {
            location.reload()
        } else {
            window.location.href = '/'
        }
    })
}

function parseInitConditions(affiliateId, set) {
    let referrer = affiliates.find(affiliate => affiliateId === affiliate.id);
    if (referrer && set) {
        setAffiliateAttributes(referrer);
    } else if (referrer && !set) {
        return referrer
    }
}

async function syncCustomerCartIds(id) {
    let affiliate = parseInitConditions(id);
    await fetch('https://en30d5wdhd0qcrs.m.pipedream.net', {
        method: "POST",
        body: JSON.stringify({
            'affiliate_id': affiliate.id,
            'customer_id': customerId
        })
    })
    .then(function(response) {
        console.log(response)
    })
}

if (paramsAffiliateId && paramsAffiliateId === 'reset') {
    setAffiliateAttributes(null)
} else {
    // IF URL has ID, and customer and cart do not
    if (paramsAffiliateId && customerAffiliateId === '' && cartAffiliateId === '') {
        parseInitConditions(paramsAffiliateId, true)
    // IF URL and cart have ID, but ID's do not match
    } else if (paramsAffiliateId && cartAffiliateId !== '' && paramsAffiliateId !== cartAffiliateId) {
        parseInitConditions(paramsAffiliateId, true)
    // IF URL and Customer have ID's that do not match, and cart does not
    } else if (paramsAffiliateId && customerAffiliateId !== '' && paramsAffiliateId !== customerAffiliateId && cartAffiliateId === '') {
        parseInitConditions(paramsAffiliateId, true)
    } else if (customerId !== '' && cartAffiliateId !== '' && cartAffiliateId !== customerAffiliateId) {
        syncCustomerCartIds(cartAffiliateId)
    }
}

// TO DO:
// Collection page
// Collection / link builder